<template>
  <div class="animated fadeIn">
    <basic-heading title="Sample Types" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'list sample type'">
      <template #gated-content>
        <sample-type-server-table />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import SampleTypeServerTable from "@/components/lab/sampletype/SampleTypeServerTable";
import { AccessControlCheck } from "@/auth/AccessControlCheck"

export default {
  name: "SampleTypeIndex",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    SampleTypeServerTable,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-plus",
            linkto: "/sampletypes/add",
            title: "Add sample type",
            variant: "success",
            permission: this.checkPermission("add sample type")
          }
        ],
        dropdown: {
          items: [
            {
              icon: "fa-sort",
              linkto: "/sampletypes/sort",
              text: "Sort sample types"
            }
          ]
        }
      };
    }
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    }
  },
};
</script>
